import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { __t } from '@mssgme/shared';
import styles from './styles.scss';

export const CardReviewsPaneHeader = ({ reviewsCountAll, reviewsCountPositive, reviewsCountNegative }) => (
    <div className={styles.root}>
        <h6 className={styles.heading}>{__t('reviews', [reviewsCountAll])}</h6>
        <div className={styles.counterBlock}>
            <span className={classNames(styles.counter, styles.green)}>{reviewsCountPositive}</span>
            <span className={classNames(styles.counter, styles.red)}>{reviewsCountNegative}</span>
        </div>
    </div>
);

CardReviewsPaneHeader.propTypes = {
    reviewsCountAll: PropTypes.number.isRequired,
    reviewsCountPositive: PropTypes.number.isRequired,
    reviewsCountNegative: PropTypes.number.isRequired,
};
